import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/SmoothScroll";
import Grain from "@/components/Grain";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import TestGuard from "@/pages/TestGuard";
import Trial from "@/pages/Trial";
import Demo from "@/pages/Demo";
import Admin from "@/pages/Admin";

// Host-based routing: campuspath.org -> CampusPath landing, testguard.org -> TestGuard
// landing, app.campuspath.org / app.testguard.org -> product demo booking.
function hostConfig() {
  // Standalone TestGuard deployment: force the TestGuard product at the root.
  if ((process.env.REACT_APP_PRODUCT || "").toLowerCase() === "testguard") {
    return { type: "testguard" };
  }
  const h = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
  if (h.startsWith("app.")) {
    return { type: "demo", product: h.includes("testguard") ? "testguard" : "campuspath" };
  }
  if (h.includes("testguard")) return { type: "testguard" };
  return { type: "campuspath" };
}

function RootRoute() {
  const cfg = hostConfig();
  if (cfg.type === "testguard") return <TestGuard />;
  if (cfg.type === "demo") return <Demo product={cfg.product} />;
  return <Home />;
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App relative">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <Grain />
            <ScrollManager />
            <Routes>
              <Route path="/" element={<RootRoute />} />
              <Route path="/testguard" element={<TestGuard />} />
              <Route path="/trial" element={<Trial />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#002244",
                  color: "#fff",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: "14px",
                  fontFamily: "Satoshi, sans-serif",
                },
              }}
            />
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
